<template>
  <div>
    <div class="app-header">
      <img :alt="$config.client.name" :src="logoPath"/>
    </div>
    <div class="center">
      <b-container class="msg">
        <p>
          {{ $t('signout.message') }}<br>
        </p>
        <b-button type="button" variant="outline-primary" data-test="signOut-signIn" @click.prevent="$router.push({ name: 'SignIn' })">
          {{ $t('signout.toSignIn') }}
        </b-button>
      </b-container>
    </div>
    <small class="footer">
      <p>{{ $t('footer') }} <a href="https://www.neogeo.fr/" target="_blank" rel="noopener">Neogeo-Technologies</a></p>
    </small>
  </div>
</template>

<script>

import loginAPI from '@/api/loginAPI.js';

export default {
  name: 'SignOut',

  data: () => {
    return {
      next: null,
    };
  },

  computed: {

    logoPath() {
      return require(process.env.VUE_APP_LOGO);
    }
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.next = to.query.next;
      loginAPI.globalSignOut().then(() => {
        if (loginAPI.logged) {
          vm.$router.push({ name: 'SignOutFailed' })
        } else {
          vm.redirectAfterSignOut();
        }
      })
    });
  },

  methods: {
    redirectAfterSignOut() {
      if (this.next) {
        if (
          this.$config.authorizedRedirections.some(reg => {
            return reg.test(decodeURIComponent(this.next))
          })
        ) {
          window.location.href = this.next;
        } else {
          this.$router.push({ name: 'NotFound' });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.center {
  position: initial;
}

.center .msg.container {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.center .msg.container,
.center .msg.container button {
  font-size: large;
}

.footer {
  position: absolute;
  bottom: 0;
  font-size: small;
}

.footer a {
  text-decoration: none;
}
</style>
